<template>
  <popup-slot>
    <quiz-card />
    <quiz-number />
    <quiz-point-name />
    <quiz-url />
    <quiz-description />
    <quiz-hints />

    <button-close />
  </popup-slot>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import QuizCard from '@/components/PopupQuiz/Card'
import QuizNumber from '@/components/PopupQuiz/Number'
import QuizPointName from '@/components/PopupQuiz/PointName'
import QuizUrl from '@/components/PopupQuiz/Url'
import QuizDescription from '@/components/PopupQuiz/Description'
import QuizHints from '@/components/PopupQuiz/Hints'
import ButtonClose from '@/components/PopupQuiz/ButtonClose'
import PopupSlot from '@/components/PopupQuiz/Slot'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    QuizCard,
    QuizNumber,
    QuizPointName,
    QuizUrl,
    QuizDescription,
    QuizHints,
    ButtonClose,
    PopupSlot
  }
}
</script>

